import React from 'react';
import { Modal as AntModal, Spin } from 'antd';
import styled from 'styled-components';
import Color from '../../../enums/color';
import Button from '../button/Button';
import { automationIds } from '../../../constants/automationIds';
import store from '../../../store';
import useGlobalState from '../../../hooks/useGlobalState';
import { ButtonClassType } from '../../../enums/buttons';
import isNil from 'lodash.isnil';
const StyledModal = styled(AntModal) `
	& .ant-modal-content {
		padding: 8px;
	}

  & .ant-modal-body {
		max-height: 70vh;
    overflow: auto;
	}

  & .ant-modal-close-x svg {
    fill: ${Color.MicrosoftBlue};
    opacity: 0.6;
  }

  & .ant-modal-close-x svg:hover {
    fill: ${Color.MicrosoftBlue};
    opacity: 1;
  }

	& .ant-modal-footer {
		padding: 16px 24px;
		display: flex;
		justify-content: flex-end;
	}

	& .ant-modal-footer button + button {
		margin-left: 8px;
	}
`;
const Modal = ({ id, title, destroyOnClose = true, closable, centered = true, maskClosable = false, width = 500, cancelButtonProps, okButtonProps, children, className, onCancel }) => {
    const modalStore = store.modal[id];
    const modalState = useGlobalState(modalStore);
    const { isOpen, isLoading, relatedData } = modalState;
    const handleCancel = () => {
        if (onCancel)
            onCancel();
        modalStore.closeModal();
    };
    const getCancelButton = () => {
        if (!cancelButtonProps)
            return;
        const { name, onClick, disabled, classType = ButtonClassType.Flat, automationId = automationIds.BUTTON.CANCEL_MODAL, ...rest } = cancelButtonProps;
        const handleCancelButtonClick = () => {
            if (onClick)
                onClick();
            handleCancel();
        };
        return (<Button name={name} key={name} onClick={handleCancelButtonClick} disabled={disabled || isLoading} automationId={automationId} classType={classType} {...rest}/>);
    };
    const getOkButton = () => {
        if (!okButtonProps)
            return;
        const { name, onClick, disabled, automationId = automationIds.BUTTON.OK_MODAL, ...rest } = okButtonProps;
        const handleOkButtonClick = () => {
            if (onClick)
                onClick(relatedData);
        };
        return (<Button name={name} key={name} onClick={handleOkButtonClick} disabled={disabled || isLoading} automationId={automationId} {...rest}/>);
    };
    const footer = [getCancelButton(), getOkButton()];
    return (<StyledModal title={title} visible={isOpen} onCancel={handleCancel} destroyOnClose={destroyOnClose} closable={closable} centered={centered} maskClosable={maskClosable} width={width} className={className} keyboard={false} footer={footer.some(item => !isNil(item)) ? footer : null} modalRender={(node) => (<Spin spinning={isLoading} wrapperClassName='modal-spinner-container'>
          {node}
        </Spin>)}>
      {children}
    </StyledModal>);
};
export default Modal;
